/**
 * Helper function to convert attrsMap into a string
 * @param {object} node
 */
const compileAttrsMap = node => {
	return Object.keys(node?.attrsMap ?? {})
		.map(key => `${key}="${node.attrsMap[key]}"`)
		.join(" ")
}

/**
 * Helper function to add meta data on each node that is needed for editor
 * @param {object} node
 */
const injectMetaData = node => {
	return `data-node-id="${node.id}"`
}

/**
 * Compiler for version 2.6.11
 * @param {*} editorAst
 * @param {*} mode
 * 	- "editor" will append some data-attributes neede for the editor
 *  - "file" produces clean output that should be saved
 */
const compiler2_6_11 = ({ editorAst, mode = "editor" }) => {
	// If there is more root nodes, we have to wrap the component into only one root node
	let output = editorAst?.length > 1 ? "<JBox>" : "" // if there is more children on the root, we have to put it under one node; vue 2 doesn't support fragments

	const recursion = arr => {
		arr.forEach(node => {
			if (!node.component) return // if no comonent, return; some nodes are not components, e.g. comments

			output += `<${node.component}
				${compileAttrsMap(node)} 
				${mode === "editor" ? injectMetaData(node) : ""}
      >`

			output += node.content ? `${node.content}` : ""

			if (node.children) recursion(node.children)
			output += `</${node.component}>`
		})
	}

	recursion(editorAst ?? [])
	output += editorAst?.length > 1 ? "</JBox>" : ""

	return output
}

/**
 * Versioned compilers
 */
const compilersProvider = {
	"2.6.11": compiler2_6_11
}

/**
 * compileEditorAstToVueTemplate
 * @param {array} editorAst
 * @param {string} mode
 * @param {string} version
 */
export default ({ editorAst, mode = "editor", version = "" }) => {
	const compiler = compilersProvider[version]
	if (!compiler) throw new Error(`There is no compiler for Vue of version ${version} available`)

	return compiler({ editorAst, mode })
}
